import React from 'react'

import LiveSimulationCard from './live-simulation-card'

interface LiveSimulationsProps {
    liveSimulations?: ExamSimulation[]
}
const LiveSimulationsSection = (props: LiveSimulationsProps) => {
    return (
        <div className="mb-3 mt-5 flex gap-3">
            {props.liveSimulations &&
                props.liveSimulations?.map((simulation) => (
                    <div
                        key={simulation._id}
                        style={{ flex: 1 / (props.liveSimulations?.length || 1) }}
                        className="h-full">
                        <LiveSimulationCard numberOfLiveSim={props.liveSimulations?.length} liveSim={simulation} />
                    </div>
                ))}
        </div>
    )
}

export default LiveSimulationsSection
